module.exports = __webpack_public_path__ + "static/parade-2019-house20-ab5426fa3d7d5dfbae7a439c1f4d0aab.jpg";